import { ENDPOINT } from 'api/endPoints/getScheduleQualityScore';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { SMALL } from 'components/Dashboards/Reporting/reportingConfig';

export const scheduleQualityScore: IHashmapItemComponentProps = {
    NoPermissionMessage,
    componentKey: 'scheduleQualityScore',
    title: 'Schedule Quality Score',
    id: 'scheduleQualityScore',
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
        },
        widgetInitialSize: SMALL,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: false,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
};
